<template>
    <div>
        <div>
            <tsoft-finance-payments
                :key="tableComponentRefreshKey"
                :additionalGetParameter="additionalGetParameter"
                :isNeedCreate="false"
            />
        </div>
    </div>
</template>

<script>
    import tsoftFinancePayments from '../components/finance/FinancePaymentsFinderAndCreator'

    export default {
        components: {
            'tsoft-finance-payments': tsoftFinancePayments
        },
        data() {
            return {
                tableComponentRefreshKey: 0,
                additionalGetParameter: ''
            }
        },
        watch: {
            $route(to, from) {
                this.additionalGetParameterChooser()
            },
        },
        mounted() {
            this.additionalGetParameterChooser()
        },
        methods: {
            additionalGetParameterChooser() {
                if (this.$route.params.finance_id) {
                    this.additionalGetParameter = `&finance_id=${this.$route.params.finance_id}`
                } else {
                    this.additionalGetParameter = ''
                }
                this.tableComponentRefreshKey += 1;
            },
        }
    }
</script>
